export default "__VITE_ASSET__DBz1t$$5__"